module.exports = __webpack_public_path__ + "img/bird-tattoos-150-5810c075db95e__700.jpg";